module.exports = __webpack_public_path__ + "static/media/settings.6e008dc9.svg";